import {Injectable} from '@angular/core';
import {PaginatorService} from "@shared/api/services/paginator.service";
import {FormQuestion} from "@shared/api/models/query/form.model";
import {map, Observable} from "rxjs";
import {PatientFormResultUpdate} from "@shared/api/models/command/patient-form-result.model";
import { HttpClient } from "@angular/common/http";
import {environment} from "../../../../../environments/environment";
import {PatientFormResult} from "@shared/api/models/query/patient-form-result.model";

@Injectable({
    providedIn: 'root'
})
export class PatientFormResultsService {
    constructor(protected http: HttpClient) {
    }

    get(patientId: number, formId: number): Observable<PatientFormResult> {
        const url = `${environment.baseApiUrl}v2/patients/${patientId}/forms/${formId}/results`;
        return this.http.get<PatientFormResult>(url)
            .pipe(
                map((response) => {
                    return response;
                })
            )
    }

    create(data: Partial<PatientFormResultUpdate>): Observable<any> {
        const url = `${environment.baseApiUrl}v2/patients/${data.patientId}/forms/${data.formId}/results`;
        return this.http.post<any>(url, data)
    }
}
